import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'spw-separator',
  styleUrl: 'spw-separator.scss',
  shadow: true,
})
export class SpwSeparator {
  /** Permet de choisir la surface du séparateur (clair ou sombre) */
  @Prop() surface: 'dark' | 'light' = 'dark';

  /** Permet de définir la direction du séparateur */
  @Prop() direction: 'vertical' | 'horizontal' = 'horizontal';

  /** Définit l'épaisseur du séparateur */
  @Prop() thickness: 1 | 2 = 1;

  /** Largeur du séparateur (par défaut 100% si non spécifié) */
  @Prop() width: string = '100%';

  /** Hauteur du séparateur (par défaut 100% si non spécifié) */
  @Prop() height: string = '100%';

  private get elementClass(): { [className: string]: boolean } {
    return {
      'spw-separator': true,
      [`spw-separator--${this.surface}`]: true,
      [`spw-separator--${this.direction}`]: true,
      [`spw-separator--thickness-${this.thickness}`]: true,
    };
  }

  private get style(): { [key: string]: string } {
    return {
      width: this.direction === 'horizontal' ? `${this.width}px` : `${this.thickness}px`,
      height: this.direction === 'vertical' ? `${this.height}px` : `${this.thickness}px`,
    };
  }

  render() {
    return <div class={this.elementClass} style={this.style}></div>;
  }
}
